import { render } from "./FollowersByGenderChart.vue?vue&type=template&id=fdbd65de&scoped=true&ts=true"
import script from "./FollowersByGenderChart.vue?vue&type=script&lang=ts"
export * from "./FollowersByGenderChart.vue?vue&type=script&lang=ts"

import "./FollowersByGenderChart.vue?vue&type=style&index=0&id=fdbd65de&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdbd65de"]])

export default __exports__